var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnitionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65754 7.52297V9.5015L4.78208 10.377L5.65754 11.2524L4.78208 12.1279L5.65754 13.0033L5.65754 14.7542L3.90663 16.5051L2.15572 14.7542V7.52297C1.42546 7.13263 0.846571 6.50947 0.511021 5.75246C0.175471 4.99546 0.1025 4.14804 0.3037 3.34482C0.504901 2.5416 0.968733 1.82864 1.62151 1.31921C2.2743 0.809775 3.07859 0.533081 3.90663 0.533081C4.73466 0.533081 5.53896 0.809775 6.19174 1.31921C6.84452 1.82864 7.30835 2.5416 7.50955 3.34482C7.71075 4.14804 7.63778 4.99546 7.30223 5.75246C6.96668 6.50947 6.3878 7.13263 5.65754 7.52297ZM5.76259 3.37332C5.76236 3.00625 5.65336 2.64749 5.44936 2.34233C5.24535 2.03718 4.95549 1.79932 4.61638 1.65881C4.27727 1.51829 3.90413 1.48142 3.54408 1.55285C3.18403 1.62428 2.85323 1.80081 2.59344 2.06014C2.24559 2.4086 2.05036 2.88095 2.05066 3.37332L5.76259 3.37332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnitionOff);
export default __webpack_public_path__ + "static/media/ignition_off.e101e283f48d9142df01e8a2a0782d2f.svg";
export { ForwardRef as ReactComponent };